module.exports = __webpack_public_path__ + "static/media/closeModal.79c43e28.svg";